import { Theme } from '@mui/material/styles'

const muiOutlinedInput = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        borderRadius: 10,
        '&.Mui-disabled': {
          color: theme.colors.placeholder,
          background: theme.colors.subHover,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: `${theme.colors.stroke} !important`,
            cursor: 'not-allowed'
          }
        },
        '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main
          }
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.colors.stroke,
          top: '0',
          '& legend': {
            display: 'none'
          }
        },
        '& .Mui-readOnly': {
          color: theme.palette.text.secondary
        },
        '&::-internal-autofill-selected': {
          background: 'transparent'
        }
      },
      input: {
        padding: '0.685rem 0.875rem',
        fontWeight: 400
      },
      multiline: {
        padding: 0,
        overflow: 'hidden'
      }
    }
  }
}

export default muiOutlinedInput
